"use client"

import styled from "@emotion/styled"
import { BasicBanner } from "ui"
import Container from "ui/Container"

type Props = {
  data: any
  locale: string
}

const StyledDiv = styled.div`
  padding-bottom: 54px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-bottom: 64px;
  }
`

export default function BasicBannerBlock({ data, locale }: Props) {
  return (
    <Container>
      <StyledDiv>
        <BasicBanner data={data} locale={locale} />
      </StyledDiv>
    </Container>
  )
}
